import BaseModel from "lib/model";

export default BaseModel.extend({
    props: {
        carrier_code: {
            type: "string",
        },
        carrier_delivery_days: {
            type: "string",
        },
        carrier_friendly_name: {
            type: "string",
        },
        carrier_id: "string",
        carrier_nickname: "string",
        final_amount: "number",
        formattedPrice: "string",
        service_type: "string",
        order_number: "string",
        order_status: "string",
    },
});
